// import ons from "onsenui";
import * as React from "react";
import PinDots from "./PinDots";
import PinKeyboard from "./PinKeyboard";

export interface PinInputProps {
  value: string;
  onChange: (pin: string) => void;
}

export const PIN_LENGTH = 4;

const PinInput = (props: PinInputProps) => {
  return (
    <div className="PinInput">
      <PinDots length={props.value.length} />
      <PinKeyboard value={props.value} onChange={props.onChange} />
    </div>
  );
};

export default React.memo(PinInput);
